import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class DownloadHelperService {
    /**
     * Triggers a browser download of a given Blob.
     * @param blob The file data as Blob
     * @param filename The name for the downloaded file
     */
    downloadBlob(blob: Blob, filename: string, openInNewTab = false): void {
        const blobUrl = URL.createObjectURL(blob);

        if (openInNewTab) {
            window.open(blobUrl, '_blank');
        }

        //temp anchor-tag
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        //cleanup
        a.remove();
        URL.revokeObjectURL(blobUrl);
    }
}


